<section
    class="nw-expansion-list__container"
    [class.nw-expansion-list__container--border]="border"
>
    <div class="nw-expansion-list__container__content">
        @if (heading) {
            <h2>{{ heading }}</h2>
        }
        @if (subheading) {
            <p class="nw-expansion-list__container__content__subheading">
                {{ subheading }}
            </p>
        }
        @if (media) {
            @if (media && media.type === 'image') {
                <img
                    class="nw-expansion-list__container__content__image margin-bottom-l"
                    [ngSrc]="media.path"
                    [alt]="media.alt"
                    height="400"
                    width="800"
                    nwTint
                    [tint]="media.tint"
                    [id]="media.id + 'image'"
                />
            }
            @if (media && media.type === 'video') {
                <video
                    class="margin-bottom-l"
                    autoplay
                    loop
                    muted
                    playsinline
                    disablepictureinpicture
                    disableremoteplayback
                    x-webkit-airplay="deny"
                    width="100%"
                    height="100%"
                    controlsList="nodownload"
                    [attr.id]="media.id + 'video'"
                    [style.filter]="
                        media.tint && media.tint !== 'none' ? 'url(#tint)' : undefined
                    "
                    nwTint
                    [tint]="media.tint"
                >
                    <source [src]="media.path" type="video/mp4" />
                </video>
            }
        }
        @for (item of items; track $index) {
            <nw-expansion-panel
                class="nw-expansion-list__container__content__item"
                [attr.header]="item.heading"
                [attr.body]="item.content"
            >
                <div role="header">{{ item.heading }}</div>
                <div role="body" [innerHTML]="item.content | sanitizeHtml"></div>
            </nw-expansion-panel>
        }
        @if (callToAction) {
            <a
                [href]="callToAction.path"
                class="nw-button nw-button--primary nw-button--m margin-top-xs"
            >
                <span [innerHTML]="callToAction.label | sanitizeHtml"></span>
            </a>
        }
    </div>
</section>
